import { API_REQUEST, GET_PROPERTIES } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export const validateWac = (payload: Record<string, string | number>): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/income/validate-wac`,
        next: GET_PROPERTIES,
        method: 'POST',
        data: payload,
        authorization: true
    }
})